import { fm } from 'Components/FormatMessage';
import FormRow from 'Components/FormRow';
import FormSection from 'Components/FormSection';
import InputHandler from 'Components/InputHandler';
import OptionChooser from 'Components/OptionChooser';
import { withFormContext } from 'Containers/FormContextHandler';
import * as React from 'react';
import { ReferenceText } from 'Routes/Diagnosis/utils/styled';

import type { IFormContext } from 'Containers/FormContextHandler';

const MGFAForm = ({ editing, formData }: IFormProps): React.JSX.Element => (
  <FormSection>
    <FormRow title="general.date">
      <InputHandler
        type="PartialDate"
        editing={!!editing}
        name="date"
        formData={formData}
        dateDefault="now"
        isNotCancellable={true}
      />
    </FormRow>
    <FormRow title="diagnosis.mgravis.mgfa.classification" bottomMargin={true}>
      <OptionChooser
        formData={formData}
        viewing={!editing}
        name="classification"
        opts={['I', 'II', 'IIa', 'IIb', 'III', 'IIIa', 'IIIb', 'IV', 'IVa', 'IVb', 'V']}
        optionFormatter={(opt: string | number) => fm(`diagnosis.mgravis.mgfa.opts.${opt}`)}
        isSecondaryOption={(opt: string | number): boolean =>
          typeof opt === 'string' && (opt.includes('a') || opt.includes('b'))
        }
        allInstructionsOpenAtOnce={true}
      />
    </FormRow>
    <ReferenceText>
      Jaretzki A, Barohn RJ, Ernstoff RM, et al. Myasthenia Gravis: Recommendations for Clinical Research Standards.
      Neurology. 2000;55(1):16-23. doi:10.1212/WNL.55.1.16.
    </ReferenceText>
  </FormSection>
);

type IFormProps = IFormContext;

export default withFormContext(MGFAForm);
